/* Local dependencies */
import { Order } from '../../../shared/types';
import {
  CreateOrderActionTypes,
  CreateOrderError,
  CreateOrderFormFields,
  CreateOrderInput,
  CreateOrderRequest,
  CreateOrderSuccess,
  ResetCreateOrderState,
  ResetError,
  UpdateCreateOrderFields,
  ValidationAllFields,
  ValidationAllFieldsOptions,
} from './types';

export function createOrderRequest(input: CreateOrderInput): CreateOrderRequest {
  return {
    type: CreateOrderActionTypes.CREATE_ORDER_REQUEST,
    input,
  };
}

export function createOrderSuccess(order: Order): CreateOrderSuccess {
  return {
    type: CreateOrderActionTypes.CREATE_ORDER_SUCCESS,
    order,
  };
}

export function createOrderError(error: Error): CreateOrderError {
  return {
    type: CreateOrderActionTypes.CREATE_ORDER_ERROR,
    error,
  };
}

export function resetError(): ResetError {
  return {
    type: CreateOrderActionTypes.RESET_ERROR,
  };
}

export function updateOrderFields(fields: Partial<CreateOrderFormFields>): UpdateCreateOrderFields {
  return {
    type: CreateOrderActionTypes.UPDATE_CREATE_ORDER_FIELDS,
    fields,
  };
}

export function resetCreateOrderState(): ResetCreateOrderState {
  return {
    type: CreateOrderActionTypes.RESET_CREATE_ORDER_STATE,
  };
}

export function validationAllFields(options?: ValidationAllFieldsOptions): ValidationAllFields {
  return {
    type: CreateOrderActionTypes.VALIDATION_ALL_FIELDS,
    options,
  };
}
